import React from 'react';
import { Box } from '@mui/material';

const ChatbotIcon = (props) => {
  return (
    <Box
      component="img"
      src="/chatbot.svg"
      alt="Chatbot"
      sx={{
        width: '1.5em',
        height: 'auto',
        padding: '2px',
        display: 'inline-block',
        filter: 'brightness(0) saturate(100%) invert(1)',
        ...props.sx,
      }}
    />
  );
};

export default ChatbotIcon;
